import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class InitService {


  async init(): Promise<void> {
    console.log('🚀 Avvio inizializzazione store...');

    console.log('✅ Inizializzazione asincrona.');

    console.log('✅ Inizializzazione store completata.');
  }
}
